export const AIR_MODULE_LABEL = 'Air Permitting';
export const SHUT_IN_COMMENT = 'Site is shut in, no production.';
export const RETAIN_LINE = 'Retain this document for a minimum of 5 years.';
export const WEEKDAY_LETTERS = ['S', 'M', 'T', 'W', 'R', 'F', 'S'];

export const OPACITY_STEPS = [
  'Perform this check daily when the sources are operating and weather conditions allow.',
  'Use this daily log to record the observations.',
  'Note whether visible emissions are present, observe all sources, and note whether conditions appear normal.',
  'If no visible emissions are observed, no further observations are required.',
  'If emissions are visible, or are believed to exceed 20% opacity, record these characteristics: (a) color of emissions, (b) light or heavy emissions, (c) cause of abnormalities, (d) duration of visible emissions, and (e) any corrective action to be taken.'
];

export const OPACITY_CERT = 'I hereby certify that I am trained to complete a VE inspection and have done so properly according to the above stated standards.';

export const FLARE_CERT = 'I hereby certify that I have the authorization to conduct and record this daily flare log, and that I have the proper training and authorization to complete the necessary inspections and the appropriate corrective actions to re-light the flare and to thus resolve any remaining and/or resulting issues.';

export const REIGNITE_STEPS = [
  'Evaluate the fuel supply and the ignition system.',
  'Light the flare manually with a flare gun or lightning pole.',
  'Watch the flare for 5 minutes.',
  'Repair the automatic ignition system.'
];

export const FLARE_CHECKS = [
  { key: 'checkFuelSupply', actionKey: 'fuelSupplyActionTaken', label: 'Check site fuel supply' },
  { key: 'checkPilotFuel', actionKey: 'pilotFuelActionTaken', label: 'Check fuel supply to the pilot system is working properly' },
  { key: 'checkPilotNotClogged', actionKey: 'pilotClogActionTaken', label: 'Check pilot fuel supply is not plugged or clogged' },
  { key: 'checkIgnition', actionKey: 'ignitionActionTaken', label: 'Check ignition system and associated control panel' },
  { key: 'checkSparkPlug', actionKey: 'sparkPlugActionTaken', label: 'Clean the spark plug ignitor or plug, and replace it if necessary' }
];

export const YES_NO_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' }
];

export function userDisplayName(user) {
  const first = user?.firstName || user?.FirstName || '';
  const last = user?.lastName || user?.LastName || '';
  const name = `${first} ${last}`.trim();
  return name || user?.fullName || user?.FullName || user?.email || user?.Email || '';
}

export function yesNoToBool(value) {
  if (value === 'yes' || value === true) return true;
  if (value === 'no' || value === false) return false;
  return null;
}

export function boolToYesNo(value) {
  if (value === true || value === 1) return 'yes';
  if (value === false || value === 0) return 'no';
  return '';
}
